<template>
	<div class="dropdown-sortir m-0">
		<button class="btn btn-secondary dropdown-toggle font-weight-600 p-0"
		        type="button"
		        :id="id" data-toggle="dropdown" aria-haspopup="true"
		        aria-expanded="false"
		        v-html="title"
		>
		</button>
		<div class="dropdown-menu force-scroll">
			<div
				v-for="(item, i) in items" :key="i"
				:class="{'selected-filter' :  item.selected, 'f-c-blue' : item.selected}"
			>
				<div class="f-regular f-16 f-c-midgrey py-2 p-x-16" v-if="Object.keys(keyReplacer).length > 0">
					{{ keyReplacer[i] }}
				</div>
				<div class="f-regular f-16 f-c-midgrey py-2 p-x-16" v-else>
					{{ i }}
				</div>
				<div v-for="(v, idx) in item"
				     @click="action(i, v, idx)"
				     class="dropdown-item f-regular f-16 f-c-black py-2 p-l-24"
				     :class="{'selected-filter' :  v.selected, 'f-c-blue' : v.selected}"
				>
					{{ v.title }}
					<img v-if="v.selected" src="../../../assets/icons/checked-blue.svg" alt="" class="m-l-12">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SODropdownGrouped",
	props: {
		id: String,
		items: Object,
		title: String,
		keyReplacer: Object,
	},
	watch: {
		items: {
			handler: function (val) {
				this.items = val
			},
			deep: true,
			immediate: true
		},
	},
	methods: {
		action(key, item, i) {
			let clone = JSON.parse(JSON.stringify(this.items))
			for (let cloneKey in clone) {
				let loopClone = clone[cloneKey]
				for (let i = 0; i < loopClone.length; i++) {
					loopClone[i].selected = false
				}
				clone[cloneKey] = loopClone
			}

			let temp = JSON.parse(JSON.stringify(clone[key]))
			temp[i].selected = true

			clone[key] = temp
			this.$emit("update-data", clone)
			this.$emit("action", item.action)
			this.$emit("selected-value", item.value)
		}
	}
}
</script>

<style scoped>
.selected-filter {
	background-color: #E9F0FF;
}

.force-scroll {
	height: 200px;
	overflow-y: scroll;
}
</style>